export default Object.freeze({
  1: "한국은행",
  2: "산업은행",
  3: "기업은행",
  4: "국민은행",
  7: "수협은행",
  8: "수출입은행",
  11: "농협은행",
  12: "지역농-축협",
  20: "우리은행",
  23: "SC제일은행",
  27: "한국씨티은행",
  31: "대구은행",
  32: "부산은행",
  34: "광주은행",
  35: "제주은행",
  37: "전북은행",
  39: "경남은행",
  45: "새마을금고연합회",
  48: "신협",
  50: "저축은행",
  52: "모건스탠리은행",
  54: "HSBC은행",
  55: "도이치은행",
  57: "제이피모간체이스은행",
  58: "미즈호은행",
  59: "엠유에프지은행",
  60: "BOA",
  61: "비엔피파리바은행",
  62: "중국공상은행",
  63: "중국은행",
  64: "산림조합중앙회",
  65: "대화은행",
  66: "교통은행",
  67: "중국건설은행",
  71: "우체국",
  76: "신용보증기금",
  77: "기술보증기금",
  81: "KEB하나은행",
  88: "신한은행",
  89: "케이뱅크",
  90: "카카오뱅크",
  101: "한국신용정보원",
  102: "대신저축은행",
  103: "에스비아이저축은행",
  104: "에이치케이저축은행",
  105: "웰컴저축은행",
  106: "신한저축은행",
});
